import { CSSProperties } from "react";

export default function ChartSkeleton() {
  const chartStyles: CSSProperties = {
    minHeight: "500px",
    display: "block",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "relative",
  };

  const axisStyles: CSSProperties = {
    position: "absolute",
    content: "",
    left: "2%",
    bottom: "2%",
    height: "96%",
    width: "1px",
    background: "#f5f5f5",
  };

  const barContainerStyles: CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    marginLeft: "0px",
    display: "block",
  };

  const barStyles: CSSProperties = {
    background: "#f5f5f5",
    position: "absolute",
    width: "3.4%",
    bottom: "2%",
  };

  const heights = [12, 17, 14, 18, 30, 37, 46, 70, 47, 72, 88, 92, 78, 98, 82];

  return (
    <div style={chartStyles}>
      {/* <div style={axisStyles}></div> */}
      <div style={{ ...axisStyles, width: "96%", height: "1px" }}></div>
      <div style={barContainerStyles}>
        {heights.map((height, i) => (
          <div
            key={i}
            className="skeleton-box"
            style={{ ...barStyles, height: `${height}%`, marginLeft: `${i * 6.6 + 3.2}%` }}
          ></div>
        ))}
      </div>
    </div>
  );
}
